import { PaginationDto } from "../../types/pagination.dto";
import { UserDto } from "../../types/user.dto";
import { UsersDto } from "../../types/users.dto";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const RESET_GET_ALL_USERS = "RESET_GET_ALL_USERS";
export const GET_ALL_USERS_SUCCESS = "GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_ERROR = "GET_ALL_USERS_ERROR";
export const UPDATE_USERS = "UPDATE_USERS";
export const RESET_UPDATE_USERS = "RESET_UPDATE_USERS";
export const UPDATE_USERS_SUCCESS = "UPDATE_USERS_SUCCESS";
export const UPDATE_USERS_ERROR = "UPDATE_USERS_ERROR";
export const GET_ALL_USERS_BY_ACADEMY = " GET_ALL_USERS_BY_ACADEMY";
export const DELETE_USER_FROM_ENTITY = "DELETE_USER_FROM_ENTITY";

export interface GetAllUsers {
  type: typeof GET_ALL_USERS;
  payload: PaginationDto;
}
export interface GetAllUsersSuccess {
  type: typeof GET_ALL_USERS_SUCCESS;
  payload: UsersDto[];
}
export interface GetAllUsersError {
  type: typeof GET_ALL_USERS_ERROR;
  payload: string | boolean;
}
export interface ResetGetAllUsers {
  type: typeof RESET_GET_ALL_USERS;
  payload: null;
}

export interface UpdateUsers {
  type: typeof UPDATE_USERS;
  payload: any;
}
export interface UpdateUsersSuccess {
  type: typeof UPDATE_USERS_SUCCESS;
  payload: any;
}
export interface UpdateUsersError {
  type: typeof UPDATE_USERS_ERROR;
  payload: string | boolean;
}
export interface ResetUpdateUsers {
  type: typeof RESET_UPDATE_USERS;
  payload: null;
}

export interface DeleteUsersFromEntity {
  type: typeof DELETE_USER_FROM_ENTITY;
  payload: any;
}

export interface GetUsersByAcademy {
  type: typeof GET_ALL_USERS_BY_ACADEMY;
  payload: { _id: string };
}

export interface State {
  all: {
    data: UsersDto[] | null;
    states: {
      loading: boolean;
      success: boolean;
      error: boolean | string;
    };
  };
  update: {
    data: null | UserDto;
    states: {
      loading: boolean;
      success: boolean;
      error: boolean | string;
    };
  };
}

export const initialState: State = {
  all: {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
  update: {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
};
export type Actions =
  | GetAllUsers
  | GetAllUsersSuccess
  | GetAllUsersError
  | ResetGetAllUsers
  | GetUsersByAcademy
  | UpdateUsers
  | UpdateUsersSuccess
  | UpdateUsersError
  | ResetUpdateUsers
  | DeleteUsersFromEntity;
